import {
    getQuoteForm,
    getPremiumCalculation,
    getOrderStatus,
    getCustomerIdValue,
} from '../../../selectors/domesticInsurance/quote';
import { getPersonalDetailsForm } from '../../../selectors/domesticInsurance/personalDetails';
import { getBuildingDetailsForm } from '../../../selectors/domesticInsurance/buildingDetails';
import { getDocumentsForm } from '../../../selectors/domesticInsurance/documents';
import { getIsApiPending } from '../../../selectors/domesticInsurance/documents';
import {
    submitPayloadDataSuccess,
    submitPayloadDataFailure,
} from '../../../actions/domesticInsurance/payloadCollection';
import { getAgentForm } from '../../../selectors/domesticInsurance/travelAgentModal';
import { getAccessToken, getPaymentStatusData, getModeOfPayments } from '../../../selectors/domesticInsurance/payments';
import axios from 'axios';
import { apiTransitionDocumentsForm } from '../../../actions/domesticInsurance/Documents';
import { setExpiredAuth } from '../../../actions/domesticInsurance/quote';


function convertToISOFormat(dateStr) {
    // Split the input date string by '/'
    const [day, month, year] = dateStr.split('/');

    // Create a new Date object using the parsed values
    const date = new Date(`${year}-${month}-${day}`);

    // Get the components of the date in 'yyyy-mm-dd' format
    const formattedYear = date.getFullYear();
    const formattedMonth = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const formattedDay = String(date.getDate()).padStart(2, '0');

    return `${formattedYear}-${formattedMonth}-${formattedDay}`;
}

export const documentsSubmitService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionDocumentsForm.pending());
            try {
                const customerId = getCustomerIdValue(store.getState());

                const state = store.getState();
                let resp;

                if (customerId.value) {
                   
                    resp = await update(state, customerId.value);
                    store.dispatch(submitPayloadDataSuccess(resp.data));
                    store.dispatch(apiTransitionDocumentsForm.success());

                } else {
                    throw new Error('Invalid Customer ID');
                }
            } catch (e) {
                console.error(e);
                if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
                    store.dispatch(setExpiredAuth(true));
                }
                store.dispatch(submitPayloadDataFailure(e));
                store.dispatch(apiTransitionDocumentsForm.failure());
            }
        }
    })();
    return next(action);
};

const payloadCollection = (state) => {
    const quotation = getQuoteForm(state);
    const personalDetails = getPersonalDetailsForm(state);
    const buildingDetails = getBuildingDetailsForm(state);
    const documents = getDocumentsForm(state);
    const agent = getAgentForm(state);
    const premium = getPremiumCalculation(state);
    const modeOfPayments = getModeOfPayments(state);
    const paymentsData = getPaymentStatusData(state);
    const orderStatus = getOrderStatus(state);

    const premiumCalculationPayload = {
        countryCode: 'KE',
        annualPremium: premium.value.premium,
        coverStartDate: convertToISOFormat(quotation.coverStartDate.value),
        coverLimit: Number(quotation?.buildingSum?.value) || Number(0 + quotation?.contentsSum?.value) || 0,
        valueOfLaptops: null,
        valueOfMobilePhones: null,
        valueOfOtherItems: null,
        valueOfBuilding: quotation?.buildingSum?.value ? Number(quotation?.buildingSum?.value) : null,
        selectedCover: quotation?.selectedCover?.value,
        phoneNumber: quotation?.phoneNumber?.value,
        emailAddress: quotation?.email?.value,
        firstName: quotation?.firstName.value,
        surname: quotation?.surname.value,
    };

    const cover = {
        allRisks: quotation?.allRisksOption?.value ? quotation?.risksSum?.value : 0,
        ownersLiability: quotation?.ownersOption?.value ? quotation?.ownersSum?.value : 0,
        domesticServants: quotation?.domesticServantsOption?.value ? quotation?.domesticServantsNo?.value : 0,
        occupiersLiability: quotation?.occupiersOption?.value ? quotation?.occupiersAmount?.value : 0,
    };

    const buildingDetailsPayload = {
        interestOfFinancialInstitution: buildingDetails?.hasFinacialInterest?.value === 'No' ? false : true,
        financialInstitutionInfo: buildingDetails?.finacialInstitution?.value || 'N/A',
        premisesStreet: buildingDetails?.streetOfPremise?.value || 'N/A',
        premisesTown: buildingDetails?.townOfPremise?.value || 'N/A',
        buildingType: buildingDetails?.buildingType?.value || 'N/A',
        propertyUse: buildingDetails?.useOfProperty?.value || 'N/A',
        roofType: buildingDetails?.roofNature?.value || 'N/A',
        wallType: buildingDetails?.wallNature?.value || 'N/A',
        location: buildingDetails?.location?.value || 'N/A',
        numberOfFloors: buildingDetails?.noOfFloors?.value ? Number(buildingDetails?.noOfFloors?.value) : null,
        lrNumber: buildingDetails?.lrNumber?.value || 'N/A',
        securityAvailable: buildingDetails?.security?.value || 'N/A',
        valueOfPerimeterWall: buildingDetails?.perimeterWall?.value
            ? Number(buildingDetails?.perimeterWall?.value)
            : null,
        valueOfLandscaping: buildingDetails?.landScaping?.value ? Number(buildingDetails?.landScaping?.value) : null,
        valueOfSwimmingPool: buildingDetails?.swimmingPool?.value ? Number(buildingDetails?.swimmingPool?.value) : null,
        valueOfContents: quotation?.contentsSum?.value ? Number(quotation?.contentsSum?.value) : null,
    };

    const personalDetailsPayload = {
        firstName: personalDetails.firstName.value || quotation?.firstName?.value || 'N/A',
        lastName: personalDetails.lastName.value || quotation?.surname?.value || 'N/A',
        emailAddress: personalDetails.email.value || quotation?.email?.value || 'N/A',
        dateOfBirth: personalDetails.dob.value ? convertToISOFormat(personalDetails.dob.value) : null,
        idNumber: personalDetails.idNumber.value,
        phoneNumber: personalDetails.phoneNumber.value || quotation?.phoneNumber?.value,
        taxPinNumber: personalDetails.tinNumber.value,
        postalAddress: personalDetails.postalAddress.value,
        streetAddress: personalDetails.streetAddress.value,
        suburb: personalDetails.suburbs.value,
        city: personalDetails.city.value,
    };

    const documentsPayload = {
        taxPinCertificate: documents.kraUpload.value ? documents.kraUpload.value.base64File : null,
        nationalIdCopy: documents.idUpload.value ? documents.idUpload.value.base64File : null,
        insuredItems: documents.insuredItemsUpload.value ? documents.insuredItemsUpload.value.base64File : null,
    };

    const agentPayload = {
        agentCode: agent?.agentCode?.value || 'N/A',
        agentName: agent?.name?.value || 'N/A',
    };

    const paymentPayload = {
        // remove hard coded value
        paymentReference: paymentsData?.CheckoutRequestID || 'N/A',
        paymentChannel: modeOfPayments.value || 'N/A',
    };

    const stepPayload = {
        onboardingStep: orderStatus,
    };

    return {
        ...premiumCalculationPayload,
        ...personalDetailsPayload,
        ...buildingDetailsPayload,
        ...documentsPayload,
        ...agentPayload,
        ...paymentPayload,
        ...stepPayload,
        ...cover,
    };
};

const update = async (state, customerId) => {
    const loginData = getAccessToken(state);
    try {
        const url = `/om-api/domestic-insurance/submit-payload/${customerId}`;

        return await axios.put(url, payloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
